import {
  OscPreChatHeaderProps,
  wiseOwlOneAdminCopy,
  wiseOwlViewCopy,
  wiseOwlZendeskCopy,
} from "@twiliointernal/org/twilio/e2-commons/shared/definitions";

export const oscPreChatConfiguration: OscPreChatHeaderProps = {
  hasImage: true,
  headerText: wiseOwlViewCopy.preChat.headerText,
  subText: wiseOwlViewCopy.preChat.subText,
  anchorProps: {
    children: wiseOwlViewCopy.preChat.anchorText,
    // link to quick start guide
    href: "https://help.twilio.com/articles/18133722687643",
    showExternal: true,
  },
};

export const wozdPreChatConfiguration: OscPreChatHeaderProps = {
  hasImage: false,
  headerText: wiseOwlZendeskCopy.preChat.headerText,
  anchorProps: {
    children: wiseOwlZendeskCopy.preChat.anchorText,
    // link to quick start guide
    href: "https://switchboard.twilio.com/sites/customer-support/resource/45393/process-wise-owl-in-zendesk",
    showExternal: true,
  },
};

export const oneAdminPreChatConfiguration: OscPreChatHeaderProps = {
  hasImage: true,
  headerText: wiseOwlOneAdminCopy.preChat.headerText,
};
